import { takeLatest, call, fork, put } from 'redux-saga/effects';
import { BYO_MARKETS_REQUEST } from '../constants';
import { marketFetchingStarted, saveMarkets } from '../actions/markets';
import { showEventLevelError } from '../actions/errors';
import { hideEventLevelError } from '../actions';
import { getMarketsData } from '../../dataProviders';
function* getMarketsSaga(action) {
    try {
        const { locale, eventId, useBYOFreedom } = action.payload;
        yield put(hideEventLevelError());
        yield put(marketFetchingStarted());
        // @ts-ignore: Yield error
        const response = yield call(getMarketsData, locale, eventId, useBYOFreedom);
        yield put(saveMarkets(response));
    }
    catch (error) {
        yield put(showEventLevelError(error.toString()));
    }
}
function* getMarketsWatcher() {
    yield takeLatest(BYO_MARKETS_REQUEST, getMarketsSaga);
}
const marketsSagas = [
    fork(getMarketsWatcher),
];
export default marketsSagas;
